import React from 'react';
import { Cross2Icon, CheckIcon, TrashIcon, VideoIcon } from '@radix-ui/react-icons';
import styles from './AddLeadCampaign.module.css';
import { assetUrl, isVideoUrl, isEmbedUrl, embedPoster } from './campaignFormUtils';

// Modal grid of every asset in the media library. Picking one adds it to the
// campaign; assets already on the campaign are badged and stay visible.
const MediaLibraryPicker = ({ library, loading, creativeItems, onPick, onRequestDelete, onClose }) => (
    <div className={styles.pickerBackdrop} onClick={onClose}>
        <div className={styles.pickerPanel} onClick={(e) => e.stopPropagation()}>
            <div className={styles.pickerHeader}>
                <span>Media library</span>
                <button type="button" className={styles.removeBtn} onClick={onClose} title="Close"><Cross2Icon /></button>
            </div>
            {loading ? (
                <div className={styles.emptyImages}>Loading…</div>
            ) : library.length === 0 ? (
                <div className={styles.emptyImages}>No images in the library yet. Upload one to get started.</div>
            ) : (
                <div className={styles.pickerGrid}>
                    {library.map((a) => {
                        const added = creativeItems.some((it) => it.asset_id === a.id);
                        return (
                            <div key={a.id} className={added ? styles.pickerItemAdded : styles.pickerItem}>
                                <button
                                    type="button"
                                    className={styles.pickerAddArea}
                                    onClick={() => onPick(a)}
                                    title={added ? 'Already added' : (a.original_name || 'Add')}
                                >
                                    {isEmbedUrl(a.file_url) ? (
                                        embedPoster(a.file_url)
                                            ? <img src={embedPoster(a.file_url)} alt="" />
                                            : <span style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: '100%', height: '100%' }}><VideoIcon /></span>
                                    ) : isVideoUrl(a.file_url) ? (
                                        <video src={assetUrl(a.file_url)} muted playsInline preload="metadata" />
                                    ) : (
                                        <img src={assetUrl(a.file_url)} alt={a.alt_text || ''} />
                                    )}
                                </button>
                                {added && <span className={styles.pickerBadge}><CheckIcon /></span>}
                                <button
                                    type="button"
                                    className={styles.pickerDelete}
                                    onClick={() => onRequestDelete(a)}
                                    title="Delete from library"
                                >
                                    <TrashIcon />
                                </button>
                            </div>
                        );
                    })}
                </div>
            )}
        </div>
    </div>
);

export default MediaLibraryPicker;
